export default "__VITE_ASSET__WnEYH9FF__"